import { useState } from 'react';
import { useCommerciaux } from '../../../../../../hooks/fetchers/useCommerciaux/useCommerciaux';
import Empty from '../../../../../commons/Empty/Empty';
import Loading from '../../../../../commons/Loading/Loading';

export default () => {
  const [currentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(10);

  const {
    data: commerciaux,
    isLoading,
    error,
  } = useCommerciaux({ page: currentPage, perPage: itemsPerPage });

  return (
    <table className="dashboard__table dashboard-commerciaux__table">
      {isLoading || error ? (
        error ? (
          <Empty>Aucune consultation pour le moment</Empty>
        ) : (
          <Loading />
        )
      ) : (
        <>
          <thead>
            <tr>
              <th>Prénom</th>
              <th>Nom</th>
              <th>Adresse email</th>
              <th>N° de téléphone</th>
            </tr>
          </thead>
          <tbody>
            {commerciaux?.results.map(({ firstName, lastName, email, phone }, index) => (
              <tr key={index}>
                <td>{firstName}</td>
                <td>{lastName}</td>
                <td>{email}</td>
                <td>{phone}</td>
              </tr>
            ))}
          </tbody>
        </>
      )}
    </table>
  );
};
